import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchActiveEmployeeShift } from '@/services/employeeShiftService';
import { useEffect } from 'react';

/**
 * Simple cached hook for employee shift data
 * Replaces manual loading states and provides 5-minute caching
 */
export function useEmployeeShiftData(employeeId: string | null, otDate?: string) {
  return useQuery({
    queryKey: ['employee-shift', employeeId, otDate],
    queryFn: () => fetchActiveEmployeeShift(employeeId!, otDate),
    enabled: !!employeeId,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    retry: 1
  });
}

/**
 * Prefetch shift data for visible employees (simple version)
 */
export function usePrefetchEmployeeShifts(employeeIds: string[], enabled = false) {
  const queryClient = useQueryClient();
  
  useEffect(() => {
    if (!enabled || !employeeIds.length) return;
    
    // Prefetch first 5 employees only (keep it simple)
    employeeIds.slice(0, 5).forEach(employeeId => {
      queryClient.prefetchQuery({
        queryKey: ['employee-shift', employeeId],
        queryFn: () => fetchActiveEmployeeShift(employeeId),
        staleTime: 5 * 60 * 1000,
      });
    });
  }, [employeeIds, enabled, queryClient]);
}
